import script from "./ClientsBlockPanelList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientsBlockPanelList.vue?vue&type=script&setup=true&lang=ts"

import "./ClientsBlockPanelList.vue?vue&type=style&index=0&id=81bfde1a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81bfde1a"]])

export default __exports__